function executorEvents() {
  const searchSelectId = $('.js-modal-search');
  const executorId = document.getElementById('executor-id').dataset.executorId;
  const eventId = document.getElementById('event-id').dataset.eventId;
  const temporaryRegistrationId = document.getElementById(
    'temporary-registration-id'
  ).dataset.temporaryRegistrationId;
  const resultRow = document.getElementById('executor-events-search-results');

  //get data from API - select options
  searchSelectId.select2({
    placeholder: 'Vyberte účastníka',
    ajax: {
      type: 'POST',
      url: '/api/executor/participants',
      dataType: 'json',
      data: function () {
        return {
          executorId: executorId,
          eventId: eventId,
        };
      },
      processResults: function (data) {
        return {
          results: $.map(data, function (obj) {
            return { id: obj.email, text: obj.name };
          }),
        };
      },
      cache: true,
    },
  });

  // trigger when select of user is done
  searchSelectId.on('select2:select', function (e) {
    var selectData = e.params.data;
    $.ajax({
      type: 'POST',
      url: '/api/executor/add-participant',
      data: {
        participantId: selectData.id,
        temporaryRegistrationId: temporaryRegistrationId,
      },
      success: function (data) {
        resultRow.innerHTML = '';
        data.forEach(function (item) {
          let titleBeforeName = item.title_before_name
            ? item.title_before_name
            : null;
          let titleAfterName = item.title_after_name
            ? item.title_after_name
            : null;
          resultRow.innerHTML =
            resultRow.innerHTML +
            createResultRow(
              titleBeforeName,
              item.first_name + ' ' + item.last_name,
              titleAfterName,
              item.email,
              item.status,
              item.email
            );
        });
        watchParticipantRows();
      },
    });
  });

  //trigger when user is removed
  searchSelectId.on('select2:unselect', function (e) {
    var selectData = e.params.data;
    $.ajax({
      type: 'POST',
      url: '/api/executor/remove-participant',
      data: {
        participantId: selectData.id,
        temporaryRegistrationId: temporaryRegistrationId,
      },
      success: function (data) {
        resultRow.innerHTML = '';
        data.forEach(function (item) {
          let titleBeforeName = item.title_before_name
            ? item.title_before_name
            : null;
          let titleAfterName = item.title_after_name
            ? item.title_after_name
            : null;
          resultRow.innerHTML =
            resultRow.innerHTML +
            createResultRow(
              titleBeforeName,
              item.first_name + ' ' + item.last_name,
              titleAfterName,
              item.email,
              item.status,
              item.employee_number
            );
        });
        watchParticipantRows();
      },
    });
  });
}

function createResultRow(
  titleBeforeName,
  name,
  titleAfterName,
  email,
  status,
  id
) {
  let nameDiv = '<span>' + name + '</span>';
  let titleBeforeNameDiv = '<span>' + titleBeforeName + '</span>';

  if (titleAfterName != null) {
    nameDiv = '<span>' + name + ' ,' + titleAfterName + '</span>';
  }

  if (titleBeforeName == null) {
    titleBeforeNameDiv = '<span></span>';
  }

  return (
    '<div class="results__row"><div class="results__name">' +
    titleBeforeNameDiv +
    nameDiv +
    '</div>' +
    '<span class="right">' +
    email +
    '</span>' +
    '<span class="right">' +
    status +
    '</span>' +
    ' <span class="right">' +
    '<button class="btn btn--icon">' +
    '<span class="icon icon--icon-trash trash-icon" data-employee-number="' +
    id +
    '">' +
    '<svg class="icon__svg"><use xlink:href="#icon-trash"></use></svg>' +
    '</span>' +
    '</button>' +
    '</span>' +
    '</div>'
  );
}

function watchParticipantRows() {
  const searchSelectId = $('.js-modal-search');
  let trashIcons = document.getElementsByClassName('trash-icon');

  trashIcons.forEach(function (trashIcon) {
    trashIcon.addEventListener('click', (event) => {
      let employeeId = event.currentTarget.dataset.employeeNumber;
      let removedOption = $(
        '.js-modal-search option[value="' + employeeId + '"]'
      );
      removedOption.prop('selected', false);
      searchSelectId.trigger('change');
      searchSelectId.trigger({
        type: 'select2:unselect',
        params: {
          data: {
            id: employeeId,
          },
        },
      });
    });
  });
}
